import React from 'react';
import { FiCompass } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t-4 border-orange-600 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 border-b border-zinc-800 pb-12 mb-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 text-2xl font-black text-white tracking-tighter mb-6">
              <SafeIcon icon={FiCompass} className="text-orange-600 w-8 h-8" />
              <span>TRAIL<span className="text-orange-600">FORGE</span></span>
            </div>
            <p className="text-zinc-500 font-medium text-sm leading-relaxed mb-6">
              Equipment engineered for the unforgiving. We build gear that outlasts the elements, the terrain, and your expectations.
            </p>
          </div>

          <div>
            <h4 className="font-black uppercase tracking-widest text-white mb-6">Equipment</h4>
            <ul className="space-y-3 text-zinc-400 font-bold uppercase text-sm tracking-wide">
              <li><a href="#" className="hover:text-orange-500 transition-colors">Outerwear</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Footwear</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Packs</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Shelter</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-black uppercase tracking-widest text-white mb-6">Support</h4>
            <ul className="space-y-3 text-zinc-400 font-bold uppercase text-sm tracking-wide">
              <li><a href="#" className="hover:text-orange-500 transition-colors">Warranty Claim</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Shipping Info</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Size Guide</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Contact Basecamp</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-black uppercase tracking-widest text-white mb-6">Join The Ranks</h4>
            <p className="text-zinc-500 text-sm mb-4">Sign up for field reports and new gear drops.</p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="EMAIL ADDRESS" 
                className="bg-zinc-900 border border-zinc-700 px-4 py-3 w-full text-white focus:outline-none focus:border-orange-500 uppercase text-xs tracking-widest"
              />
              <button className="bg-orange-600 hover:bg-orange-500 text-white px-4 py-3 font-black uppercase text-sm transition-colors border border-orange-500">
                Send
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-zinc-600 text-xs font-bold uppercase tracking-widest">
          <p>&copy; {new Date().getFullYear()} TrailForge Gear Co. All Rights Reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="#" className="hover:text-zinc-300">Privacy</a>
            <a href="#" className="hover:text-zinc-300">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;